import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IVehicleData } from '../../../../core/models/vehicle-data.model';
import {
  ILocationInfo,
  ISummaryData,
  ProductInformation,
} from '../../../../core/models/summary-data';
import { SummaryService } from '../../../../core/services/summary.service';
import { StepKey } from '../../../../core/enums/stepper.enum';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { CatalogService } from '../../../../core/services/catalog.service';
import { FunnelService } from './funnel.service';
import { CategoryId } from '../../../../core/enums/category.enum';
import { BookRequest, MappedProduct, MappedTopping, ServerProduct, ServerTopping } from '../../../../core/interfaces/funnel.interface';
import { myToppingDictionary } from '../../../../core/utils/topping-dictionary';
import { isSame } from 'ngx-bootstrap/chronos';
import { LoaderService } from '../../../../core/services/loader.service';
import { finalize } from 'rxjs';

@Component({
  selector: 'app-funnel',
  standalone: false,
  templateUrl: './funnel.component.html',
  styleUrl: './funnel.component.scss',
})
export class FunnelComponent {
  summaryData: ISummaryData = {} as ISummaryData;
  vehicleDataForm: FormGroup = {} as FormGroup;
  locationInfoForm: FormGroup = {} as FormGroup;

  StepKey = StepKey;
  currentStep: StepKey = StepKey.Vehicle;
  @Output() stepChanged = new EventEmitter<StepKey>();
  form!: FormGroup;
  productCatalogResponse: any;
  mappedToppings: MappedTopping[] = [];
  brandingId: string = '';

  constructor(
    private fb: FormBuilder,
    private summaryService: SummaryService,
    private router: Router,
    private location: Location,
    private route: ActivatedRoute,
    private productCatalogService: CatalogService,
    private catalogDataService: CatalogService,
    private funnelService: FunnelService,
    private loaderService: LoaderService
  ) {
    this.form = this.fb.group({
      vehicleData: this.fb.group({
        licensePlate: ['', Validators.required],
        model: ['', Validators.required],
        brand: ['', Validators.required],
        fuelType: [null, Validators.required],
        vehicleType: [null, Validators.required],
        brandingId: [''],
      }),
      locationInfo: this.fb.group({
        destinationAddress: ['', Validators.required],
        destinationAddressDetails: [''],
        destinationAddressLatitude: [null, Validators.required],
        destinationAddressLongitude: [null, Validators.required],
        isSameAddress: [true],
        isSelected: [true],
        originAddress: ['', Validators.required],
        originAddressDetails: [''],
        originAddressLatitude: [null, Validators.required],
        originAddressLongitude: [null, Validators.required],
      }),
      productSelection: this.fb.group({
        // id: [null, Validators.required],
        // title: [null, Validators.required],
        // icon: [null, Validators.required],
        // description: [null, Validators.required],
        // personalizationDescription: [null, Validators.required],
        // price: [null, Validators.required],
        // caflerFee: [null, Validators.required],
        // addedNonScheduleMotPrice: [null, Validators.required],
        // verticalType: [null, Validators.required],
        // relatedCarts: [null, Validators.required],
        // selectedSubcategory: [null, Validators.required],
        // outOfRange: [null, Validators.required],
        // outOfRangeTitle: [null, Validators.required],
        // outOfRangeIcon: [null, Validators.required],
        id: [null],
        title: [null],
        icon: [null],
        description: [null],
        personalizationDescription: [null],
        price: [null],
        caflerFee: [null],
        addedNonScheduleMotPrice: [null],
        verticalType: [null],
        relatedCarts: [null],
        selectedSubcategory: [null],
        outOfRange: [null],
        outOfRangeTitle: [null],
        outOfRangeIcon: [null],
      }),
    });

    this.vehicleDataForm = this.form.get('vehicleData') as FormGroup;
    this.locationInfoForm = this.form.get('locationInfo') as FormGroup;
  }

  ngOnInit(): void {

    this.brandingId = this.route.snapshot.queryParamMap.get('brandingId') || '';

    const summary = this.summaryService.getSummary();
    if (summary) {
      this.summaryData = summary;
    }

    this.route.firstChild?.url.subscribe((segments) => {
      const path = segments[0]?.path;

      switch (path) {
        case 'vehicle-data':
          this.currentStep = StepKey.Vehicle;
          break;
        case 'pickup':
          this.currentStep = StepKey.Pickup;
          break;
        case 'catalog':
          this.currentStep = StepKey.Catalog;
          break;
        case 'summary':
          this.currentStep = StepKey.DateTime;
          break;
        case 'extras':
          this.currentStep = StepKey.Extras;
          break;
        case 'overview':
          this.currentStep = StepKey.Overview;
          break;
        default:
          this.currentStep = StepKey.Vehicle;
      }
    });

    this.location.subscribe(() => {
      if (this.currentStep > StepKey.Vehicle) {
        this.currentStep--;
      }
    });

    this.catalogDataService.productInfo$.subscribe((data) => {
      this.onCatalogDataReceived(data);
    });
  }

  onSubmit(): void {}

  get vehicleData(): FormGroup {
    return this.form.get('vehicleData') as FormGroup;
  }

  get locationInfo(): FormGroup {
    return this.form.get('locationInfo') as FormGroup;
  }

  get productSelection(): FormGroup {
    return this.form.get('productSelection') as FormGroup;
  }

  onVehicleDataReceived(data: IVehicleData) {
    this.summaryData = {
      ...this.summaryData,
      vehicleData: data,
    };

    this.summaryService.setSummary(this.summaryData);
    this.onStepChanged(StepKey.Pickup);
    this.router.navigate(['/funnel/pickup'], {
      queryParams: { brandingId: this.brandingId },
    });
  }

  OnLocationInfoReceived(data: ILocationInfo) {
    this.summaryData = {
      ...this.summaryData,
      locationInfo: data,
    };

    this.summaryService.setSummary(this.summaryData);
    this.onStepChanged(StepKey.Catalog);
    this.router.navigate(['/funnel/catalog'], {
      queryParams: { brandingId: this.brandingId },
    });
  }

  onCatalogDataReceived(data: ISummaryData){
    this.summaryData = {
      ...this.summaryData,
      productInformation: data.productInformation,
      serviceConfiguration: data.serviceConfiguration,
    };
    this.summaryService.setSummary(this.summaryData);
    this.onStepChanged(StepKey.DateTime);
    this.router.navigate(['/funnel/summary'], {
      queryParams: { brandingId: this.brandingId },
    });
  }

  onSummaryDataReceived(data: ILocationInfo) {
    this.summaryData = {
      ...this.summaryData,
      locationInfo: {
        ...this.summaryData.locationInfo,
        ...data
      },
    };

    if (this.summaryData.productInformation?.product?.id === 'valet-station') {
      this.summaryData = {
        ...this.summaryData,
        serviceConfiguration: {
          ...data.serviceConfiguration
        }
      }
    }

    this.summaryService.setSummary(this.summaryData);

    const dto = this.funnelService.prepareDtoForRequest(this.summaryData)
    const serviceVerticalType = this.summaryData.productInformation?.product?.VerticalType;
    const productName = serviceVerticalType !== undefined ? CategoryId[serviceVerticalType] : 'Unknown';
    this.loaderService.show()
    this.funnelService.bookService(dto, productName).pipe(
            finalize(() => this.loaderService.hide()),
          ).subscribe(
      (response) => {
        const responseData = response;
        this.summaryData = {
          ...this.summaryData,
          bookingResponse: responseData,
        };
        this.mappedToppings = this.mapToppings(responseData.AvailableToppings);
        localStorage.setItem('mappedToppings', JSON.stringify(this.mappedToppings));
        this.summaryService.setSummary(this.summaryData);
        this.onStepChanged(StepKey.Extras);
        this.router.navigate(['/funnel/extras'], {
          queryParams: { brandingId: this.brandingId },
        });
      },
      (error) => {
        console.error('Error booking service:', error);
      }
    );
  }

  onExtrasReceived(data: any) {
    this.onStepChanged(StepKey.Overview);
    this.router.navigate(['/funnel/overview'], {
      queryParams: { brandingId: this.brandingId },
    });
  }

  onStepChanged(step: StepKey) {
    this.currentStep = step;
  }

  getRouteForStep(step: StepKey): string {
    switch (step) {
      case StepKey.Vehicle:
        return 'vehicle-data';
      case StepKey.Pickup:
        return 'pickup';
      case StepKey.Catalog:
        return 'catalog';
      case StepKey.DateTime:
        return 'summary';
      case StepKey.Extras:
        return 'extras';
      case StepKey.Overview:
        return 'overview';
      default:
        return 'vehicle-data';
    }
  }

  goBack(): void {
    const currentUrl = this.router.url;

    if (
      currentUrl.includes('refueling') ||
      currentUrl.includes('wash') ||
      currentUrl.includes('default') ||
      currentUrl.includes('ownership-change') ||
      currentUrl.includes('parking')
    ) {
      this.router.navigate(['/funnel/catalog'], {
        queryParams: { brandingId: this.brandingId },
      });
      return;
    }

    const steps = [StepKey.Vehicle, StepKey.Pickup, StepKey.Catalog, StepKey.DateTime, StepKey.Extras, StepKey.Overview];
    const currentIndex = steps.indexOf(this.currentStep);

    if (currentIndex > 0) {
      const previousStep = steps[currentIndex - 1];
      this.currentStep = previousStep;

      const route = this.getRouteForStep(previousStep);
      this.router.navigate(['/funnel', route], {
        queryParams: { brandingId: this.brandingId },
      });
    }
  }

  receiveProductCatalogResponse(data: any) {
    this.productCatalogResponse = data;
    localStorage.setItem('ProductCatalogResponse', JSON.stringify(this.productCatalogResponse));
    this.productCatalogService.setCatalog(this.productCatalogResponse);
    this.summaryData.productInformation = {
      ZoneId: data.ZoneId,
      FinishZoneId: data.FinishZoneId,
    };
    this.summaryService.setSummary(this.summaryData);
  }

  mapToppings(serverResponse: { Categories: ServerTopping[] }): MappedTopping[] {
    return serverResponse?.Categories
      ?.filter(category => myToppingDictionary.hasOwnProperty(category.Title))
      .map(category => {
        const dictionaryInfo = myToppingDictionary[category.Title];
  
        return {
          ...dictionaryInfo,
          title: category.Title,
          sortOrder: category.SortOrder,
          products: this.mapProductsWithRelated(category.Products, dictionaryInfo),
        };
      }) || [];
  }
  

  private mapProductsWithRelated(products: ServerProduct[], dictionaryInfo: any): MappedProduct[] {
    return products.map((product) => {
      const productDictionaryInfo = dictionaryInfo.relatedToppings?.[product.ProductKey] || {};

      const mappedProduct: MappedProduct = {
        Id: product.Id || productDictionaryInfo.id || '',
        id: product.Id || productDictionaryInfo.id || '',
        productKey: product.ProductKey,
        price: product.Price,
        priceTaxes: product.PriceTaxes,
        isBundle: product.IsBundle,
        verticalType: product.VerticalType,
        caflerFee: product.CaflerFee,
        caflerFeeTaxes: product.CaflerFeeTaxes,
        icon: productDictionaryInfo.icon || dictionaryInfo.icon,
        titleId: productDictionaryInfo.titleId || dictionaryInfo.titleId,
        descriptionId: productDictionaryInfo.descriptionId || dictionaryInfo.descriptionId,
        showStartingFrom: productDictionaryInfo.showStartingFrom ?? dictionaryInfo.showStartingFrom,
        relatedProducts: [],
      };

      if (product.IsBundle && product.RelatedProducts) {
        mappedProduct.relatedProducts = this.mapRelatedProducts(
          product.RelatedProducts,
          productDictionaryInfo.relatedToppings || {}
        );
      }

      return mappedProduct;
    });
  }

  private mapRelatedProducts(
    relatedProducts: ServerProduct[],
    relatedToppingsDictionary: any
  ): MappedProduct[] {
    return relatedProducts.map((relatedProduct) => {
      const relatedProductDictionaryInfo =
        relatedToppingsDictionary[relatedProduct.ProductKey] || {};

      return {
        Id: relatedProduct.Id,
        id: relatedProduct.Id,
        productKey: relatedProduct.ProductKey,
        price: relatedProduct.Price,
        priceTaxes: relatedProduct.PriceTaxes,
        isBundle: relatedProduct.IsBundle,
        verticalType: relatedProduct.VerticalType,
        caflerFee: relatedProduct.CaflerFee,
        caflerFeeTaxes: relatedProduct.CaflerFeeTaxes,
        icon: relatedProductDictionaryInfo.icon,
        titleId: relatedProductDictionaryInfo.titleId,
        descriptionId: relatedProductDictionaryInfo.descriptionId,
        showStartingFrom: relatedProductDictionaryInfo.showStartingFrom,
        relatedProducts: [],
      };
    });
  }

}
